import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {Checkbox, FormControlLabel} from "@mui/material";
import React, {Fragment, useState} from "react";
import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";

type Props = {
    loadUser: (boolean) => void
}
export default function LoginRegister({loadUser}: Props) {

    const [loginemail, setloginemail] = useState('');
    const [loginpassword, setloginpassword] = useState('');
    const [loginresult, setloginresult] = useState('')
    const [registeremail, setregisteremail] = useState('');
    const [registerpassword, setregisterpassword] = useState('');
    const [registersl, setregistersl] = useState(false);
    const [registerresult, setregisterresult] = useState('')
    const [loading, setloading] = useState(false)

    const login = () => {
        setloading(true)
        setloginresult('')
        fetch(apiAddress + "/users/login", createOptions('POST', {
                email: loginemail,
                password: loginpassword
            })
        ).then((res) => res.json()).then((data) => {
            console.log('then',data)
            if (data.hasOwnProperty('user')) {
                localStorage.setItem('user', JSON.stringify(data.user));
                loadUser(true);
            }
            if (data.hasOwnProperty('msg')) {
                setloginresult(data.msg);
                setloading(false);
            }
            if (data.hasOwnProperty('error')) {
                let err = data?.err?.code;
                setloginresult(data.error + ' ' + err);
                setloading(false);
            }
        }).catch((exeption) => {
            console.log('login catch', exeption)
            setloginresult('login failed (exeption)');
            setloading(false);
        });
    }

    const register = () => {
        setloading(true)
        setregisterresult('')
        fetch(apiAddress + "/users/register", createOptions('POST', {
                email: registeremail,
                password: registerpassword,
                sl: registersl
            })
        ).then((res) => res.json()).then((data) => {
            setloading(false);
            console.log('register', data)
            if (data.hasOwnProperty('user')) {
                localStorage.setItem('user', JSON.stringify(data.user));
                loadUser(true);
            }
            if (data.hasOwnProperty('msg')) setregisterresult(data.msg);
            if (data.hasOwnProperty('errors') && Array.isArray(data.errors)) setregisterresult(data.errors.map(e => e.msg).join(', '));
            if (data.hasOwnProperty('error') && data.error instanceof Object) setregisterresult(JSON.stringify(data.error));
        });
    }

    return <Fragment>
        <Paper>
            <Grid container spacing={1} style={{padding: 10}}>
                <Grid item xs={4}>
                    <TextField onChange={e => setloginemail(e.target.value)}
                               value={loginemail}
                               variant="standard"
                               label="E-Mail:"
                               onKeyDown={(e) => {
                                   if (e.key === "Enter") login();
                               }}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField onChange={e => setloginpassword(e.target.value)}
                               value={loginpassword}
                               variant="standard"
                               type="password"
                               label="Passwort:"
                               onKeyDown={(e) => {
                                   if (e.key === "Enter") login();
                               }}
                    />
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={2}>
                    <Button onClick={login}>login</Button>
                </Grid>
                {loading ? 'loading...' : null}
                {loginresult ? <Grid item xs={12}>
                    {loginresult}
                </Grid> : null}
            </Grid>
        </Paper>
        <Paper>
            <Grid container spacing={1} style={{padding: 10}}>
                <Grid item xs={4}>
                    <TextField onChange={e => setregisteremail(e.target.value)}
                               value={registeremail}
                               variant="standard"
                               label="Name:"
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField onChange={e => setregisterpassword(e.target.value)}
                               value={registerpassword}
                               variant="standard"
                               type="password"
                               label="Passwort:"
                               onKeyDown={(e) => {
                                   if (e.key === "Enter") register();
                               }}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormControlLabel style={{marginLeft: 0}}
                                      label="SL?"
                                      control={
                                          <Checkbox checked={registersl || false}
                                                    onChange={
                                                        (e) => setregistersl(e.target.checked)
                                                    }/>
                                      }/>
                </Grid>
                <Grid item xs={2}>
                    <Button onClick={register}>register</Button>
                </Grid>
                {loading ? 'loading...' : null}
                {registerresult ? <Grid item xs={12}>
                    {registerresult}
                </Grid> : null}
            </Grid>
        </Paper>
    </Fragment>
}